import { flow } from 'fp-ts/function';
import { array, nonEmptyArray } from 'fp-ts';
import { createSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { ApplicationState, ResourceFeatureAssignment } from '@mews-commander/types';
import { getStringProp } from '@mews/fp';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'resourceFeatureAssignments';

export const RESOURCE_FEATURE_ASSIGNMENTS_UPDATED = prefix('RESOURCE_FEATURE_ASSIGNMENTS_UPDATED');

export const [
    getResourceFeatureAssignments,
    getResourceFeatureAssignmentByIds,
    getResourceFeatureAssignmentByOwnerId,
    getResourceFeatureAssignment,
] = createBaseEntitySelectors<ApplicationState, ResourceFeatureAssignment, typeof NAME>(parentSelector, NAME);

export const setResourceFeatureAssignments = (resourceFeatureAssignments: ResourceFeatureAssignment[]) =>
    createAction(RESOURCE_FEATURE_ASSIGNMENTS_UPDATED, resourceFeatureAssignments);

export const resourceFeatureAssignmentsReducer = createEntitiesReducer({
    UPDATE_SUCCESS: RESOURCE_FEATURE_ASSIGNMENTS_UPDATED,
});

const getResourceFeaturesGroup = createSelector(
    getResourceFeatureAssignments,
    flow(
        Object.values<ResourceFeatureAssignment>,
        nonEmptyArray.groupBy(({ resourceId }) => resourceId)
    )
);
export const getResourceFeatureAssignmentsByResourceId = createSelector(
    getResourceFeaturesGroup,
    getStringProp('resourceId'),
    (group, resourceId) => group[resourceId] ?? []
);

export const getResourceFeatureAssignmentResourceFeatureIdsByResourceId = createSelector(
    getResourceFeatureAssignmentsByResourceId,
    array.map((resourceFeatureAssignment) => resourceFeatureAssignment.featureId)
);
